module.exports = __webpack_public_path__ + "static/footer-corner-drawing-be6ff4a2c10b67fe3468b7c2122894c7.png";